import {Button, IconHelp, IconLogout, IconTalkChat} from '@sportcast/ui-react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Tooltip} from 'react-tooltip';
import {RootState} from '../../store';
import {useNavigationContext} from './NavigationContext';

function DesktopHeader() {
    const [t] = useTranslation();
    const userData = useSelector((state: RootState) => state.login.userData);
    const {logout, showHelp, showContact} = useNavigationContext();

    return (
        <div className="header-content-with-sidebar">
            <ul>
                <li>
                    <span data-tooltip-id="header-tooltip"
                          data-tooltip-content={t('header.CONTACT')}>
                    <Button
                        variant="transparentSm"
                        icon={IconTalkChat}
                        onClick={showContact}
                    />
                        </span>
                </li>
                <li>
                    <span data-tooltip-content={t('header.HELP')} data-tooltip-id="header-tooltip">
                    <Button
                        variant="transparentSm"
                        icon={IconHelp}
                        onClick={showHelp}
                    />
                    </span>
                </li>
                <li role="button" onClick={logout} data-tooltip-content={t('header.LOGOUT_USER', {user: `${userData?.firstName} ${userData?.lastName}`})}
                    data-tooltip-id="header-tooltip">
                    <Button variant="transparentSm" icon={IconLogout} label={t('header.LOGOUT')}/>
                </li>
            </ul>
            <Tooltip id="header-tooltip" variant="dark" place="bottom"/>
        </div>
    );
}

export default DesktopHeader;
